import React, { useEffect } from "react"
import { Row } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { newsActions } from "../store/actions"
import "./style.css"
import Loading from "../../../components/Loading/Local"

//import objectFitImages from "object-fit-images"
import history from "../../../helpers/history"
import { useParams } from "react-router-dom"
import NewsList from "../NewsList"
import CustomUpload from "../../../components/CustomUpload"
import getDownloadTitleImageUrl from "../DownloadImageUrls"

const OneNews = () => {
	const { news, oneNews, isSending } = useSelector((state) => state.newsReducer)
	const dispatch = useDispatch()
	const getOneNews = (params) => {
		dispatch(newsActions.getOneNews(params))
	}
	const getNews = (params) => {
		dispatch(newsActions.getNews(params))
	}
	const downloadFile = (params) => {
		dispatch(newsActions.downloadNewsFile(params))
	}
	const routeParams = useParams()

	useEffect(() => {
		window.scroll(0, 0)
		return dispatch(newsActions.clear())
	}, [])

	useEffect(() => {
		getOneNews({ id: routeParams.newsId })
	}, [routeParams.newsId])

	useEffect(() => {
		if (oneNews){
			const pageSize = 5
			getNews({
				PageSize : pageSize,
				Page     : 1,
				Search   : null
			})
		}
	}, [oneNews])

	return (
		<div className="container-news">
			<span
				className="back-button"
				onClick={ () => history.back() }
			>
				<svg
					fill="none"
					height="14"
					viewBox="0 0 7 14"
					width="7"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0.8833 8.94421L5.08988 13.148C5.26442 13.3059 5.49297 13.3905 5.7282 13.3845C5.96343 13.3784 6.18733 13.2822 6.35354 13.1156C6.51975 12.949 6.61554 12.7249 6.62108 12.4897C6.62662 12.2544 6.54149 12.0261 6.3833 11.8519L2.17947 7.64804C2.00762 7.47614 1.91108 7.24302 1.91108 6.99996C1.91108 6.75689 2.00762 6.52377 2.17947 6.35187L6.3833 2.14804C6.55518 1.97604 6.6517 1.7428 6.65161 1.49963C6.65153 1.25647 6.55485 1.0233 6.38284 0.851413C6.21084 0.67953 5.9776 0.583016 5.73443 0.583102C5.49127 0.583189 5.2581 0.679867 5.08622 0.851871L0.8833 5.05571C0.367755 5.57141 0.0781384 6.27075 0.0781384 6.99996C0.0781384 7.72916 0.367755 8.4285 0.8833 8.94421Z"
					/>
				</svg>

							Назад
			</span>
			{ !isSending && oneNews
				? (
					<>
						<Row
							align="top"
							justify="start"
						>
							<div className="topContainer">
								<img
									alt="news_image"
									className="topImage"
									src={ getDownloadTitleImageUrl(oneNews.titleImage?.id, oneNews.id) }
								/>
								<div
									className="header-text"
									id="header-text"
								>
									<h3>
										{ oneNews.title }
									</h3>
								</div>
							</div>
						</Row>
						<Row
							className="news-row-padder"
							justify="start"
						>
							<div className="htmlCenter">
								<div
									className="ql-editor"
									dangerouslySetInnerHTML={ { __html: oneNews.htmlText } }
									id="ql-editor"
								/>
							</div>
						</Row>
						{
							(oneNews.files && oneNews.files?.length)
								? (
									<div
										className="news-row-padder"
										justify="start"
									>
										<h3>
								Прикрепленные файлы
										</h3>
										<CustomUpload
											download
											defaultFileList={ oneNews.files.map(item => {
												return { ...item,
													uid: item?.id }
											}) }
											onDownload={ (file) => downloadFile({
												newsId : oneNews.id,
												fileId : file.id,
												name   : file.name
											}) }
										/>
									</div>
								)
								: null
						}
						 { (news && news.items)
							? (
								<div
									className="news-row-padder"
									justify="start"
								>
									<h3>
								Другие новости
									</h3>
									<>
										<NewsList
											news={ news.items.filter(x => x.id != oneNews?.id).slice(0, 3) }
											newsGrid={ { md : 8,
												sm : 24 } }
										/>
									</>
								</div>
							)
							: null }
					</>
				)
				: (
					<Loading />
				) }
		</div>
	)
}
export default OneNews
